




















































































































































































































































































































































































































































































































































































































































































































































































import TemplateDialog from "@/components/template/TemplateDialog.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import MIconButton from "@/components/utility/mmmint/MIconButton.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import MTextField from "@/components/utility/mmmint/MTextField.vue";
import RefsCompany from "@/components/utility/RefsCompany.vue";
import { getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import { ApplicationInsightsEventEnum } from "@/lib/enum/application-insights-event.enum";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { LanguageCodeEnum } from "@/lib/enum/language-code.enum";
import { PersonLabelEnum } from "@/lib/enum/person-label.enum";
import { TokenCategoriesEnum } from "@/lib/enum/templateEnums/tokenCategories.enum";
import { CompanyRouteNames } from "@/lib/utility/company.go-to-helper";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { handleError } from "@/lib/utility/handleError";
import { PersonRouteNames } from "@/lib/utility/person.go-to-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IAppraisal } from "@/models/appraisal.entity";
import { IClearance } from "@/models/clearance.entity";
import { CompanyAddress, ICompanyAddress } from "@/models/company-address.entity";
import { CompanyBase, ICompany } from "@/models/company.entity";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { PersonEmail } from "@/models/person-email.entity";
import { PersonPhone } from "@/models/person-phone.entity";
import { IPerson } from "@/models/person.entity";
import { Reference } from "@/models/reference.entity";
import { IRental } from "@/models/rental.entity";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { IReport } from "@/models/report.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { IVehicle } from "@/models/vehicle.entity";
import { MrfiktivPartnerViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ConfigModule } from "@/store/modules/config";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import SharedContentSideCard from "../../SharedContentSideCard.vue";
import CompanySelection from "./contact/CompanySelection.vue";
import CompanySelectionTable from "./contact/CompanySelectionTable.vue";
import PersonSelectionTable from "./contact/PersonSelectionTable.vue";
import { IAddress } from "@/models/address.entity";
import { ActivityLog } from "@/models/activity-log.entity";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";

enum ContactTabs {
  COMPANY,
  PERSON
}

enum CompanyTabs {
  OVERVIEW,
  INFO
}

enum PersonType {
  DRIVER = "DRIVER",
  OTHER = "OTHER"
}

type CompanyListType = {
  company?: ICompany | null;
  service?: CompanyServiceEnum;
};

type ContactListType = Partial<IPerson> & {
  id: string;
  type: PersonType;
};

@Component({
  components: {
    MIconButton,
    MNoContent,
    MTextField,
    CompanySelection,
    PersonSelectionTable,
    ConfirmActionDialog,
    TemplateDialog,
    SharedContentSideCard,
    RefsCompany,
    CompanySelectionTable
  },
  filters: { getFlagEmojiByLanguage }
})
export class PartnerReportDetailContact extends mixins(PermissionMixin) {
  PersonType = PersonType;

  get isLoading() {
    return this.report.isCompaniesLoading || this.report.isPersonsLoading;
  }

  get attachmentFileFilters() {
    return this.report?.refFilter || [];
  }

  get filters() {
    const filter: IPageFilterElement[] = [];

    filter.push(new PageFilterElement({ value: this.report.id, key: "refs.refId", operation: "$eq" }));

    return filter;
  }

  get fleetCompanyFilters(): IPageFilterElement[] | undefined {
    if (!this.report.fleetId) {
      return undefined;
    }
    return [
      new PageFilterElement({
        value: this.report.fleetId,
        operation: PageFilterOperationEnum.EQUAL,
        key: "refs.refId"
      })
    ];
  }

  get refs() {
    if (!this.report?.id) {
      return [];
    }
    return [{ refId: this.report.id, refType: ResourceEnum.REPORT }];
  }

  get showTowing(): boolean {
    return this.partner.settings?.companyServices?.includes(CompanyServiceEnum.TOWING) ?? false;
  }

  isAssignDialogOpen = false;
  isAssignValid = false;
  isAssignLoading = false;

  templateEditorKey = "";

  isLoadingSharedContent = false;
  isLoadingEmailDialog = false;

  isLoadingDeletePerson = false;

  resourceEnum = ResourceEnum;

  isAddContactDialogOpen = false;
  isAddContactLoading = false;
  contactToAdd: IPerson | null = null;

  companyToAdd: ICompany | null = null;
  filter: CompanyServiceEnum | null = null;

  tab = ContactTabs.COMPANY;
  companyTab = CompanyTabs.OVERVIEW;

  activeCompanyIndex: number | null = this.isMobile ? null : 0;
  activePersonIndex: number | null = this.isMobile ? null : 0;

  sharedContentSideCardItem?: ISharedContent | null = null;

  isAlignActivePersonPhoneDialogActive = false;
  isAlignActivePersonPhoneLoading = false;
  isAlignActivePersonEmailDialogActive = false;
  isAlignActivePersonEmailLoading = false;
  isAlignActivePersonAddressDialogActive = false;
  isAlignActivePersonAddressLoading = false;
  isAlignActivePersonCompanyDialogActive = false;
  isAlignActivePersonCompanyLoading = false;
  isAlignActivePersonLanguageDialogActive = false;
  isAlignActivePersonLanguageLoading = false;
  isAlignActivePersonNameDialogActive = false;
  isAlignActivePersonNameLoading = false;

  /**
   * Set the primary phone of the active person to the new number
   * @param newNumber
   */
  async setActivePersonPrimaryPhone(newNumber: string) {
    if (!this.activePerson) {
      return;
    }

    this.isAlignActivePersonPhoneLoading = true;

    let phones = [...(this.activePerson.phones ?? [])];

    // Remove MAIN type from old primary phone
    if (this.activePerson.primaryPhone) {
      phones = phones.map(p => {
        if (p.phone === this.activePerson?.primaryPhone) {
          p.label = PersonLabelEnum.OTHER;
        }
        return p;
      });
    }

    // Add new number if not in list yet
    let found = phones.find(p => p.phone === newNumber);
    if (!found) {
      found = new PersonPhone({ phone: newNumber, label: PersonLabelEnum.MAIN });
      phones.push(found);
    } else {
      // Set label to MAIN if found
      found.label = PersonLabelEnum.MAIN;
    }

    await this.activePerson
      .updatePartial({ phones: phones.map(p => p.dto) })
      .then(() => {
        this.isAlignActivePersonPhoneDialogActive = false;
      })
      .catch(handleError)
      .finally(() => {
        this.isAlignActivePersonPhoneLoading = false;
      });
  }

  /**
   * Set the primary email of the active person to the new email
   * @param newEmail
   */
  async setActivePersonPrimaryEmail(newEmail: string) {
    if (!this.activePerson) {
      return;
    }

    this.isAlignActivePersonEmailLoading = true;

    let emails = [...(this.activePerson.emails ?? [])];

    // Remove MAIN type from old primary email
    if (this.activePerson.primaryEmail) {
      emails = emails.map(e => {
        if (e.email === this.activePerson?.primaryEmail) {
          e.label = PersonLabelEnum.OTHER;
        }
        return e;
      });
    }

    // Add new email if not in list yet
    let found = emails.find(e => e.email === newEmail);
    if (!found) {
      found = new PersonEmail({ email: newEmail, label: PersonLabelEnum.MAIN });
      emails.push(found);
    } else {
      // Set label to MAIN if found
      found.label = PersonLabelEnum.MAIN;
    }

    await this.activePerson
      .updatePartial({ emails: emails })
      .then(() => {
        this.isAlignActivePersonEmailDialogActive = false;
      })
      .catch(handleError)
      .finally(() => {
        this.isAlignActivePersonEmailLoading = false;
      });
  }

  /**
   * Set the address of the active person to the new address
   * @param newAddress
   */
  async setActivePersonAddress(newAddress: IAddress) {
    if (!this.activePerson || !this.report.customerAddress) {
      return;
    }

    this.isAlignActivePersonAddressLoading = true;

    const addresses: ICompanyAddress[] = [...(this.activePerson.addresses ?? [])];
    const existingAddr = this.report.customerAddress
      ? addresses.find(a => a.toString() === newAddress.toString())
      : undefined;

    if (!existingAddr && this.report.customerAddress) {
      // Create new address with billing flag and unset previous billing flags
      addresses.forEach(a => (a.isBilling = false));
      const newAddr = new CompanyAddress({
        street: newAddress.street,
        city: newAddress.city,
        zip: newAddress.zip,
        state: newAddress.state,
        countryCode: newAddress.countryCode,
        line2: newAddress.line2,
        line3: newAddress.line3,
        isBilling: true
      });
      addresses.push(newAddr);
    } else if (existingAddr) {
      // Mark existing address as billing
      addresses.forEach(a => (a.isBilling = a.toString() === existingAddr.toString()));
    }

    await this.activePerson
      .updatePartial({
        addresses: addresses
      })
      .then(() => {
        this.isAlignActivePersonAddressDialogActive = false;
      })
      .catch(handleError)
      .finally(() => {
        this.isAlignActivePersonAddressLoading = false;
      });
  }

  /**
   * Set the language of the active person to the new language/'\'
   * @param firstName
   * @param lastName
   */
  async setActivePersonName(firstName: string, lastName: string) {
    if (!this.activePerson) {
      return;
    }

    this.isAlignActivePersonNameLoading = true;

    await this.activePerson
      .updatePartial({ firstName, lastName })
      .then(() => {
        this.isAlignActivePersonNameDialogActive = false;
      })
      .catch(handleError)
      .finally(() => {
        this.isAlignActivePersonNameLoading = false;
      });
  }

  async openSharedContent(owner: ICompany | IPerson | undefined | null, type: ResourceEnum) {
    if (!owner) {
      return;
    }
    this.isLoadingSharedContent = true;

    await this.fetchOrCreateSharedContent(owner, type).catch(handleError);

    /**
     * set shared content
     */
    if (owner.activeSharedContent) {
      this.sharedContentSideCardItem = owner.activeSharedContent;
    }

    this.isLoadingSharedContent = false;
  }

  async fetchOrCreateSharedContent(owner: ICompany | IPerson | undefined | null, type: ResourceEnum) {
    if (!owner) {
      return;
    }

    /**
     * If shared content not loaded, load
     */
    if (!owner?.activeSharedContent) {
      await owner.fetchSharedContent(this.report.id);
    }

    /**
     * if shared content not defined after loading, create new one
     */
    if (!owner.activeSharedContent) {
      owner.activeSharedContent = new SharedContent({ partnerId: this.partner.id, reportId: this.report.id });
      owner.activeSharedContent.refs = [new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT })];

      if (type === ResourceEnum.PERSON) {
        owner = owner as IPerson;
        if (!owner.activeSharedContent) {
          return;
        }

        owner.activeSharedContent.personIds = [owner.id];
        owner.activeSharedContent.emailAddresses = owner?.primaryEmail ? [owner.primaryEmail] : [];
      } else if (type === ResourceEnum.COMPANY) {
        owner = owner as ICompany;
        if (!owner.activeSharedContent) {
          return;
        }

        owner.activeSharedContent.companyIds = [owner.id];
        if (owner.contact?.email) {
          owner.activeSharedContent.emailAddresses = [owner.contact.email];
        }
      }

      await owner.activeSharedContent.create();
    }
  }

  get contactKey() {
    if (this.tab === ContactTabs.COMPANY) {
      return this.activeCompany?.company?.id;
    } else if (this.tab === ContactTabs.PERSON) {
      return this.activePerson?.id;
    }
    return "no-active-contact";
  }

  context: {
    [TokenCategoriesEnum.PARTNER]?: MrfiktivPartnerViewModelGen | null;
    [TokenCategoriesEnum.REPORT]?: IReport | null;
    vehicle?: IVehicle | null;
    [TokenCategoriesEnum.URL]?: { sharing?: string; publicReportUrl?: string };
    person?: IPerson | null;
    company?: ICompany | null;
    [TokenCategoriesEnum.RENTAL]?: IRental | null;
    [TokenCategoriesEnum.APPRAISAL]?: IAppraisal | null;
    [TokenCategoriesEnum.CLEARANCE]?: IClearance | null;
    [TokenCategoriesEnum.ESTIMATE]?: IRepairEstimate | null;
  } = {
    [TokenCategoriesEnum.PARTNER]: this.partner,
    [TokenCategoriesEnum.REPORT]: this.report,
    vehicle: this.report.vehicle
  };

  get debug() {
    return ConfigModule.debug;
  }

  get tabs() {
    return Object.keys(ContactTabs);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get activeCompany(): CompanyListType | null {
    if (this.activeCompanyIndex === null || this.activeCompanyIndex === undefined) {
      return null;
    }

    return this.companies[this.activeCompanyIndex] ?? null;
  }

  get activeCompanyPhone() {
    return this.activeCompany?.company?.contact?.phone ?? "";
  }

  get activeCompanyMail() {
    return this.activeCompany?.company?.contact?.email ?? "";
  }

  get activeCompanyAddress() {
    return this.activeCompany?.company?.billingAddress ? this.activeCompany.company.billingAddress.toString() : "";
  }

  get activePerson(): IPerson | null {
    if (this.activePersonIndex === null || this.activePersonIndex === undefined) {
      return null;
    }

    return this.persons[this.activePersonIndex];
  }

  get companies(): CompanyListType[] {
    return [
      {
        company: this.report.companyCompany
      },
      {
        company: this.report.insuranceCompany,
        service: CompanyServiceEnum.INSURANCE
      },
      { company: this.report.insuranceBrokerCompany, service: CompanyServiceEnum.INSURANCE_BROKER },
      {
        company: this.report.leasingCompany,
        service: CompanyServiceEnum.LEASING
      },
      {
        company: this.report.attorneyCompany,
        service: CompanyServiceEnum.LAWYER
      },
      ...(this.showTowing
        ? [
            {
              company: this.report.towingCompany,
              service: CompanyServiceEnum.TOWING
            }
          ]
        : []),
      {
        company: this.report.rentalCompany,
        service: CompanyServiceEnum.RENTAL
      },
      { company: this.report.workShopCompany, service: CompanyServiceEnum.WORKSHOP },

      {
        company: this.report.appraiserCompany,
        service: CompanyServiceEnum.APPRAISER
      },
      {
        company: this.report.damageBrokerCompany,
        service: CompanyServiceEnum.DAMAGE_BROKER
      }
    ];
  }

  getFlagEmojiByLanguage = getFlagEmojiByLanguage;

  serviceIconMap(service: CompanyServiceEnum | undefined) {
    if (!service) {
      return "mdi-domain";
    }
    return CompanyBase.serviceIconMapping.get(service)?.icon;
  }

  serviceName(item: CompanyListType) {
    if (!item.service) {
      return this.$t("common.nouns.customer");
    }
    return this.$t(`enums.CompanyServiceEnum.${item.service}`).toString();
  }

  typeIconMap(type: PersonType) {
    const typeIconMap = new Map([
      [PersonType.DRIVER, "mdi-steering"],
      [PersonType.OTHER, "mdi-account"]
    ]);

    return typeIconMap.get(type);
  }

  get persons(): IPerson[] {
    const persons: IPerson[] = [];

    if (this.report.person) {
      persons.push(this.report.person);
    }

    persons.push(...this.report.persons);

    return persons;
  }

  get isWhatsappOptIn() {
    return this.report.whatsAppContactOptIn;
  }

  get whatsappLink() {
    if (!this.activePerson?.primaryPhone) {
      return undefined;
    }

    const whatsappPhoneNumber = this.activePerson.primaryPhone.trim().replace(" ", "");

    return `https://wa.me/${whatsappPhoneNumber}?text=''`;
  }

  startAssignCompany(service?: CompanyServiceEnum) {
    this.filter = service ?? null;
    this.isAssignDialogOpen = true;
  }

  startAddContact() {
    this.isAddContactDialogOpen = true;
  }

  async addContact() {
    if (!this.contactToAdd) {
      return;
    }

    const personId = this.contactToAdd.id;

    const isAlreadyLinked = this.report.personId === personId || this.report.personIds?.includes(personId);
    if (isAlreadyLinked) {
      const existingIndex = this.persons.findIndex(p => p && p.id === personId);
      if (existingIndex !== -1) {
        this.activePersonIndex = existingIndex;
      }
      this.isAddContactDialogOpen = false;
      return;
    }

    if (!this.report.personIds) {
      this.report.personIds = [personId];
    } else {
      this.report.personIds.push(personId);
    }

    try {
      this.isAddContactLoading = true;

      await this.report.updatePartial({ personIds: this.report.personIds });
      this.report.persons.push(this.contactToAdd);
      this.activePersonIndex = this.report.personIds.length - 1;

      this.isAddContactDialogOpen = false;

      await new ActivityLog().createAssociatedActivity({
        source: new Reference({
          refId: this.report.id,
          refType: ResourceEnum.REPORT
        }),
        partnerId: this.partner.id,
        activityType: ActivityTypeEnum.CREATE_ASSOCIATED,
        associated: [
          new Reference({
            refId: this.contactToAdd.id,
            refType: ResourceEnum.PERSON
          })
        ],
        role: undefined
      });
    } catch (error) {
      handleError(error);
    } finally {
      this.isAddContactLoading = false;
    }
  }

  async addCompany() {
    if (!this.companyToAdd) {
      this.$log.debug("no company to add");
      return;
    }

    const service: CompanyServiceEnum | null = this.filter;
    await this.selectCompany(this.companyToAdd, service).then(() => {
      this.isAssignDialogOpen = false;
    });
  }

  async removeCompany(service: CompanyServiceEnum | null = null) {
    this.isAssignLoading = true;

    let removedId: string | undefined;

    try {
      switch (service) {
        case CompanyServiceEnum.DAMAGE_BROKER:
          removedId = this.report.damageBrokerCompanyId;
          await this.report.updatePartial({ damageBrokerCompanyId: null });
          await this.report.damageBrokerCompany?.activeSharedContent?.deactivate();

          this.report.damageBrokerCompany = null;

          break;

        case CompanyServiceEnum.INSURANCE_BROKER:
          removedId = this.report.insuranceBrokerCompanyId;
          await this.report.updatePartial({ insuranceBrokerCompanyId: null });
          await this.report.insuranceBrokerCompany?.activeSharedContent?.deactivate();

          this.report.insuranceBrokerCompany = null;

          break;

        case CompanyServiceEnum.WORKSHOP:
          removedId = this.report.workshopCompanyId;
          await this.report.updatePartial({ workshopCompanyId: null });
          await this.report.workShopCompany?.activeSharedContent?.deactivate();

          this.report.workShopCompany = null;

          break;

        case CompanyServiceEnum.APPRAISER:
          removedId = this.report.appraiserCompanyId;
          await this.report.updatePartial({ appraiserCompanyId: null });
          await this.report.appraiserCompany?.activeSharedContent?.deactivate();

          this.report.appraiserCompany = null;

          break;

        case CompanyServiceEnum.INSURANCE:
          removedId = this.report.insuranceCompanyId;
          await this.report.updatePartial({ insuranceCompanyId: null });
          await this.report.insuranceCompany?.activeSharedContent?.deactivate();

          this.report.insuranceCompany = null;

          break;

        case CompanyServiceEnum.LEASING:
          removedId = this.report.leasingCompanyId;
          await this.report.updatePartial({ leasingCompanyId: null });
          await this.report.leasingCompany?.activeSharedContent?.deactivate();

          this.report.leasingCompany = null;

          break;

        case CompanyServiceEnum.TOWING:
          removedId = this.report.towingCompanyId;
          await this.report.updatePartial({ towingCompanyId: null });
          await this.report.towingCompany?.activeSharedContent?.deactivate();

          this.report.towingCompany = null;

          break;

        case CompanyServiceEnum.LAWYER:
          removedId = this.report.attorneyCompanyId;
          await this.report.updatePartial({ attorneyCompanyId: null });
          await this.report.attorneyCompany?.activeSharedContent?.deactivate();

          this.report.attorneyCompany = null;

          break;

        case CompanyServiceEnum.RENTAL:
          removedId = this.report.rentalCompanyId;
          await this.report.updatePartial({ rentalCompanyId: null });
          await this.report.rentalCompany?.activeSharedContent?.deactivate();
          this.report.rentalCompany = null;

          break;

        case null:
          removedId = this.report.companyId;
          await this.report.updatePartial({ companyId: null });
          await this.report.companyCompany?.activeSharedContent?.deactivate();

          this.report.companyCompany = null;

          break;

        default:
          this.$log.error(`Unknown service type when removing company from report: ${service}`);
          break;
      }

      if (removedId) {
        await new ActivityLog().createAssociatedActivity({
          source: new Reference({
            refId: this.report.id,
            refType: ResourceEnum.REPORT
          }),
          partnerId: this.partner.id,
          activityType: ActivityTypeEnum.DELETE_ASSOCIATED,
          associated: [
            new Reference({
              refId: removedId,
              refType: ResourceEnum.COMPANY
            })
          ],
          role: service || undefined
        });
      }
    } catch (error) {
      handleError(error);

      throw error;
    } finally {
      this.isAssignLoading = false;
    }
  }

  async selectCompany(company: ICompany, service: CompanyServiceEnum | null = null) {
    if (!company) {
      return;
    }

    const companyId = company.id;

    this.isAssignLoading = true;

    try {
      switch (service) {
        case CompanyServiceEnum.DAMAGE_BROKER:
          await this.report.updatePartial({
            broker: {
              name: company.companyName
            }
          });
          await this.report.updatePartial({ damageBrokerCompanyId: companyId });
          this.report.damageBrokerCompany = company;

          break;

        case CompanyServiceEnum.INSURANCE_BROKER:
          await this.report.updatePartial({ insuranceBrokerCompanyId: companyId });
          this.report.insuranceBrokerCompany = company;

          break;

        case CompanyServiceEnum.WORKSHOP:
          await this.report.updatePartial({ workshopCompanyId: companyId });
          this.report.workShopCompany = company;

          break;

        case CompanyServiceEnum.APPRAISER:
          await this.report.updatePartial({ appraiserCompanyId: companyId });
          this.report.appraiserCompany = company;

          break;

        case CompanyServiceEnum.INSURANCE:
          await this.report.updatePartial({ insuranceCompanyId: companyId });
          this.report.insuranceCompany = company;

          break;

        case CompanyServiceEnum.LEASING:
          await this.report.updatePartial({ leasingCompanyId: companyId });
          this.report.leasingCompany = company;

          break;

        case CompanyServiceEnum.TOWING:
          await this.report.updatePartial({ towingCompanyId: companyId });
          this.report.towingCompany = company;

          break;

        case CompanyServiceEnum.LAWYER:
          await this.report.updatePartial({ attorneyCompanyId: companyId });
          this.report.attorneyCompany = company;

          break;

        case CompanyServiceEnum.RENTAL:
          await this.report.updatePartial({ rentalCompanyId: companyId });
          this.report.rentalCompany = company;

          break;

        case null:
          await this.report.updatePartial({ companyId: companyId });
          this.report.companyCompany = company;

          break;

        default:
          break;
      }

      await new ActivityLog().createAssociatedActivity({
        source: new Reference({
          refId: this.report.id,
          refType: ResourceEnum.REPORT
        }),
        partnerId: this.partner.id,
        activityType: ActivityTypeEnum.CREATE_ASSOCIATED,
        associated: [
          new Reference({
            refId: companyId,
            refType: ResourceEnum.COMPANY
          })
        ],
        role: service || undefined
      });

      await company.fetchSharedContent(this.report.id);
    } catch (error) {
      handleError(error);

      throw error;
    } finally {
      this.isAssignLoading = false;
    }
  }

  openWhatsapp() {
    this.$appInsights.trackEvent(
      { name: ApplicationInsightsEventEnum.OPEN_WHATSAPP },
      { partnerId: PartnerModule.partner.id }
    );

    window.open(this.whatsappLink, "Whatsapp", "width=600,height=300");
  }

  isDriver(person: IPerson) {
    return person.id === this.report.personId;
  }

  async openMail(owner: ICompany | IPerson | undefined | null, type: ResourceEnum) {
    if (!owner) {
      return;
    }

    this.isLoadingEmailDialog = true;

    await this.fetchOrCreateSharedContent(owner, type);

    let to = "";

    if (type === ResourceEnum.PERSON) {
      owner = owner as IPerson;
      to = owner.primaryEmail ?? "";
      this.context.person = owner;
      this.context.company = undefined;
    } else if (type === ResourceEnum.COMPANY) {
      owner = owner as ICompany;
      to = owner.contact?.email ?? "";
      this.context.person = undefined;
      this.context.company = owner;
    }

    if (owner.activeSharedContent?.url) {
      this.context.url = {
        sharing: owner.activeSharedContent.url,
        publicReportUrl: owner.activeSharedContent.url
      };
    } else {
      this.context.url = undefined;
    }

    if (this.report?.rentals && this.report?.rentals.length) {
      this.context[TokenCategoriesEnum.RENTAL] = this.report.rentals[0];
    }

    if (this.report?.appraisals && this.report?.appraisals.length) {
      this.context[TokenCategoriesEnum.APPRAISAL] = this.report.appraisals[0];
    }

    if (this.report?.repairEstimates && this.report?.repairEstimates.length) {
      this.context[TokenCategoriesEnum.ESTIMATE] = this.report.repairEstimates[0];
    }

    if (this.report?.clearances && this.report?.clearances.length) {
      this.context[TokenCategoriesEnum.CLEARANCE] = this.report.clearances[0];
    }

    this.templateEditorKey = `${this.contactKey}-${Date.now()}`;
    await this.$nextTick();

    this.isLoadingEmailDialog = false;

    (this.$refs.templateDialog as TemplateDialog).openTo({ to });
  }

  goToCompany(company?: ICompany) {
    if (!company) {
      return;
    }
    this.$router.push({
      name: CompanyRouteNames.COMPANY_DETAIL,
      params: { partnerId: company.partnerId, companyId: company.id }
    });
  }

  goToPerson(person?: IPerson) {
    if (!person) {
      return;
    }
    this.$router.push({
      name: PersonRouteNames.PERSON_DETAIL,
      params: { partnerId: person.partnerId, personId: person.id }
    });
  }

  async removePerson(person: IPerson) {
    if (!person) {
      return;
    }
    const personIds = this.report.personIds?.filter(id => id !== person.id);
    this.isLoadingDeletePerson = true;
    const personId = person.id === this.report.personId ? null : this.report.personId;
    try {
      await this.report.updatePartial({ personIds, personId });
      const personIndex = this.report.persons.findIndex(p => p.id === person.id);
      if (personIndex !== -1) {
        this.report.persons.splice(personIndex, 1);
      }
      if (this.report.person?.id === person.id) {
        this.report.person = null;
      }
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingDeletePerson = false;
    }

    await new ActivityLog()
      .createAssociatedActivity({
        source: new Reference({
          refId: this.report.id,
          refType: ResourceEnum.REPORT
        }),
        partnerId: this.partner.id,
        activityType: ActivityTypeEnum.DELETE_ASSOCIATED,
        associated: [
          new Reference({
            refId: person.id,
            refType: ResourceEnum.PERSON
          })
        ],
        role: undefined
      })
      .catch(e => this.$log.error(e));

    this.activePersonIndex = null;
  }

  async mounted() {
    await this.fetchFleetCompanies();
  }

  async fetchFleetCompanies() {
    await this.report.fleet?.fetchCompanies();
  }

  get suggestedFleetCompanies() {
    return this.report.fleet?.companies;
  }

  suggestFleetCompaniesByType(service: CompanyServiceEnum): ICompany[] {
    return this.suggestedFleetCompanies?.filter(c => c.services?.includes(service)) ?? [];
  }

  /**
   * Sets the active person's language in their master data
   * @param language The language to set.
   */
  async setActivePersonLanguage(language: LanguageCodeEnum) {
    if (!this.activePerson) {
      return;
    }

    this.isAlignActivePersonLanguageLoading = true;

    await this.activePerson
      .updatePartial({ language })
      .then(() => {
        this.isAlignActivePersonLanguageDialogActive = false;
      })
      .catch(handleError)
      .finally(() => {
        this.isAlignActivePersonLanguageLoading = false;
      });
  }
}
export default PartnerReportDetailContact;
